import Vue from 'vue'


Vue.prototype.iconClassName = type => {  // 全局方法  
  switch (type) {
    case "pdf":
      return "#icon-PDF";
    case "zip":
      return "#icon-ZIP";
    case "xls":
      return "#icon-XLS";
    case "jpg":
      return "#icon-JPG";
    case "docx":
      return "#icon-DOCX";
    case "ppt":
      return "#icon-PPT";
    case "mp4":
      return "#icon-mp4-1";
    case "txt":
      return "#icon-txt-1";
    default:
      return "#icon-defal-1"
  }
}
// 判空验证
Vue.prototype.isNotNull = val => {
  if ("" == val || null == val || undefined == val || "null" == val || JSON.stringify(val) == "{}") {
    return false
  }
  return true
}
// 本地存储
Vue.prototype.setLocal = (name, data) => {
  localStorage.setItem(name, JSON.stringify(data));
}
// 获取本地存储
Vue.prototype.getLocal = name => {
  return JSON.parse(localStorage.getItem(name));
}
// 获取本地Sessiong存储数据
Vue.prototype.getSession = name => {
  return JSON.parse(sessionStorage.getItem(name))
}
// 获取belong
Vue.prototype.getBelong = () => {
  let belong = localStorage.getItem('belong')
  if (belong != undefined && belong != null && belong != '') {
    return belong
  }
  return null
}
// 获取uid
Vue.prototype.uid = () => {
  if(JSON.parse(localStorage.getItem("userInfo")) == undefined || JSON.parse(localStorage.getItem("userInfo")) == null) {
    return false
  }
  return JSON.parse(localStorage.getItem("userInfo")).uid
}
// 区分ios和Android
Vue.prototype.AndroisIos = () => {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isAndroid) {
    return true;
  } else if (isIOS) {
    return false;
  }
}

/**
 * 加载js文件
 * @param {*} src js文件路径
 * @param {*} callback 加载完成回调
 */
Vue.prototype.loadScript = (src,callback) => {
  let script = document.createElement("script");
  script.type = "text/javascript";
  script.src = src;
  script.onload = function() {
    if (typeof callback === "function") {
      callback();
    }
  };
  document.head.appendChild(script);
}

Vue.prototype.queryString = (str,name) => {
  let paramArr = str ? (str.split('?')[1] ? str.split('?')[1].split('&') : []) : []
  let params = {}
  let i
  let l

  for (i = 0, l = paramArr.length; i < l; i++) {
      params[(paramArr[i].split('=')[0] || 'undefined')] = (paramArr[i].split('=')[1] || '')
  }
  return params[name] || ''
}